export default "__VITE_ASSET__B_6f1QB7__"